<template>
  <div class="container">
    <div class="card shadow pt-2 ps-3 pe-3">
      <div class="row">
        <div class="col-5 offset-1">
          <label>Nome</label>
          <input
            type="text"
            class="form-control"
            v-model="state.nome"
            placeholder="Insira o nome do grupo:"
          />
        </div>
        <div class="col-5">
          <label>Status</label>
          <select class="form-select" v-model="state.status">
            <option value="ATIVO">Ativo</option>
            <option value="INATIVO">Inativo</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="div-btn">
          <button
            class="btn btn_salvar float-end"
            id="submit-button"
            type="button"
            @click="salvarGrupo()"
          >
            Cadastrar
          </button>
          <button
            class="btn btn_voltar btn-secondary float-end me-3"
            id="voltar-button"
            type="submit"
            @click="router.push({ name: 'GrupoNegocio' })"
          >
            Voltar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      nome: "",
      status: "ATIVO",
    });
    async function salvarGrupo() {
      let dados = new FormData();
      dados.append("nome", state.nome);
      dados.append("status", state.status);
      try {
        await services.negocio.saveGrupo(dados, token);
        router.push({ name: "GrupoNegocio" });
      } catch (error) {
        console.log(error);
      }
    }
    return {
      salvarGrupo,
      router,
      state,
    };
  },
};
</script> 
<style scoped>
.btn_salvar {
  background: green;
  color: #fff;
  transform: none;
}
.btn_salvar:hover {
  color: #fff;
}

.card {
  min-height: 94.8vh;
}
.div-btn {
  margin-top: 1rem;
}
.btn_deletar_imagem {
  margin-top: 2rem;
  width: 25px;
  height: 25px;
  margin-left: 3px;
  background: rgb(170, 0, 0);
  color: #fff;
  border: solid 1px rgb(170, 0, 0);
  border-radius: 5px;
  transition: 0.3s;
}
.btn_deletar_imagem:hover {
  background: rgb(228, 0, 0);
  color: #fff;
  border: solid 1px rgb(228, 0, 0);
}
.imagem {
  height: auto;
  width: 300px;
  margin-top: 2rem;
  border-radius: 5px;
  object-fit: cover;
}
</style>